/**
 * workflowGraph — graph helpers over a v2 definition, mirroring the server's
 * adjacency rules: every edge is a flow edge, and a node's upstream is
 * everything that can reach it.
 */
import { upstreamOf } from 'features/agents/WorkflowEditor/definition';

/** All upstream nodes of `nodeId`, trigger first, nearest parent last. */
export function getUpstreamNodes(definition, nodeId) {
  if (!definition || !nodeId) return [];
  return upstreamOf(definition, nodeId);
}

/** Expression base for a field of a named upstream node. */
export function nodeExprBase(displayName) {
  return `$node[${JSON.stringify(displayName || 'Node')}]`;
}
